import React from 'react';

import PropTypes from 'prop-types';

import styled from 'styled-components';

import promoMedia from '../../../../theme/promoMedia';
import { RichText } from '../promo-dangerously-html/RichText';
import PromoIllustration from '../widgets/Illustration/PromoIllustration';

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 32px;
    padding-top: ${(props) => (props.hasTopPadding ? '32px' : null)};

    ${promoMedia.tablet744} {
        margin-bottom: 48px;
        padding-top: ${(props) => (props.hasTopPadding ? '48px' : null)};
    }

    ${promoMedia.desktop1440} {
        flex-direction: row;
        align-items: ${(props) => (props.isCenteredContent ? 'center' : 'start')};
        margin-bottom: 64px;
        padding-top: ${(props) => (props.hasTopPadding ? '64px' : null)};
    }
`;
const ImgContainer = styled.div`
    width: 335px;
    height: 335px;
    margin-bottom: 32px;
    flex-shrink: 0;

    ${promoMedia.tablet744} {
        width: 504px;
        height: 504px;
        margin-bottom: 48px;
    }

    ${promoMedia.desktop1440} {
        width: 468px;
        height: 468px;
        margin-bottom: 0;
        margin-right: 94px;
    }
`;

export const RichTextTile = (props) => {
    return (
        <Container isCenteredContent={props.isCenteredContent} hasTopPadding={props.hasTopPadding}>
            {props.img && (
                <ImgContainer>
                    <PromoIllustration img={props.img} loadingLazy={props.loadingLazy} />
                </ImgContainer>
            )}
            <RichText tag="div" dangerouslyHtml={props.text} />
        </Container>
    );
};

RichTextTile.propTypes = {
    img: PropTypes.array,
    text: PropTypes.string,
    isCenteredContent: PropTypes.bool,
    hasTopPadding: PropTypes.bool,
    loadingLazy: PropTypes.bool,
};
